import React, { Fragment } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Card, CardBody } from "reactstrap";
import PageHeading from "Layout/AppMain/PageHeading";
import Table from "./table";

const LinkPage = () => {
    return (
        <Fragment>
            <PageHeading />
           <TransitionOnLoad>
                    <Card className="main-card mb-3">
                        <CardBody>
                            <Table />
                        </CardBody>
                    </Card>
                </TransitionOnLoad>
        </Fragment>
    )
}
export default LinkPage